// Centralized pricing logic for the Top-Notch Pro Solutions Quote & Booking calculator

export const STANDARD_MATRIX = {
  1: { 1: 100, 2: 120 },
  2: { 1: 180, 2: 220, 3: 260 },
  3: { 1: 280, 2: 300, 3: 330, 4: 370 },
  4: { 1: 390, 2: 390, 3: 410, 4: 450, 5: 480 },
  5: { 1: 500, 2: 500, 3: 530, 4: 560, 5: 590 },
  6: { 1: 600, 2: 600, 3: 600, 4: 630, 5: 655 },
};

export const DEEP_MATRIX = {
  1: { 1: 200, 2: 230 },
  2: { 1: 260, 2: 290, 3: 320 },
  3: { 1: 350, 2: 380, 3: 410, 4: 440 },
  4: { 1: 470, 2: 470, 3: 500, 4: 530, 5: 560 },
  5: { 1: 590, 2: 590, 3: 620, 4: 650, 5: 680 },
  6: { 1: 710, 2: 710, 3: 710, 4: 740, 5: 770 },
};

export const FREQUENCY_OPTIONS = [
  { id: "weekly", label: "Weekly", discount: 0.15, sub: "15% off" },
  { id: "biweekly", label: "Every 2 Weeks", discount: 0.10, sub: "10% off" },
  { id: "monthly", label: "Once a Month", discount: 0, sub: "Standard rate" },
  { id: "one_time", label: "One-Time Service", discount: 0, sub: "Standard rate" },
];

export const ADDON_DEFINITIONS = (serviceType) => ([
  { id: "laundry",  label: "Laundry Service",          price: 60,  icon: "Shirt",         tabs: ["standard", "deep"] },
  { id: "fridge",   label: "Fridge Cleaning",          price: 40,  icon: "Refrigerator",  tabs: ["standard", "deep"] },
  { id: "oven",     label: "Oven Cleaning",            price: 40,  icon: "Flame",         tabs: ["standard", "deep"] },
  { id: "windows",  label: "Interior Window Cleaning", price: serviceType === "deep" ? 80 : 50, icon: "AppWindow", tabs: ["standard", "deep"] },
  { id: "pets",     label: "Cleaning Home with Pet(s)",price: 80,  icon: "PawPrint",      tabs: ["standard", "deep"] },
  { id: "baseboard",label: "Baseboard Cleaning",       price: 60,  icon: "Ruler",         tabs: ["standard", "deep"] },
  { id: "cabinet",  label: "Interior Cabinet Cleaning",price: 60,  icon: "Archive",       tabs: ["deep"] },
  { id: "basement", label: "Basement Cleaning",        price: 60,  icon: "DoorOpen",      tabs: ["deep"] },
]);

const clampBedrooms = (b) => Math.max(1, Math.min(6, parseInt(b || 1, 10)));

// Determine matrix bath column to pick (handles "1-2", "1-3" merged tiers)
function pickBathColumn(matrixForBedroom, baths) {
  const cols = Object.keys(matrixForBedroom).map(Number).sort((a, b) => a - b);
  const maxCol = cols[cols.length - 1];
  if (baths >= maxCol) return matrixForBedroom[maxCol];
  if (matrixForBedroom[baths] !== undefined) return matrixForBedroom[baths];
  // Find next higher bracket
  for (const c of cols) {
    if (c >= baths) return matrixForBedroom[c];
  }
  return matrixForBedroom[maxCol];
}

export function getBasePrice(serviceType, bedrooms, bathrooms) {
  const matrix = serviceType === "deep" ? DEEP_MATRIX : STANDARD_MATRIX;
  const b = clampBedrooms(bedrooms);
  const ba = Math.max(1, Math.min(5, parseInt(bathrooms || 1, 10)));
  const row = matrix[b];
  if (!row) return 0;
  return pickBathColumn(row, ba) || 0;
}

export function computeQuote({ serviceType, bedrooms, bathrooms, frequency, addOns }) {
  const base = getBasePrice(serviceType, bedrooms, bathrooms);
  const freq = FREQUENCY_OPTIONS.find(f => f.id === frequency) || FREQUENCY_OPTIONS[3];
  const discountAmount = +(base * freq.discount).toFixed(2);
  const discountedBase = +(base - discountAmount).toFixed(2);

  const allAddOns = ADDON_DEFINITIONS(serviceType);
  let addonsTotal = 0;
  const addOnsList = [];
  allAddOns.forEach(a => {
    if (a.tabs.includes(serviceType) && addOns[a.id]) {
      addonsTotal += a.price;
      addOnsList.push({ ...a });
    }
  });

  const serviceEstimate = +(discountedBase + addonsTotal).toFixed(2);
  const deposit = 50;
  const remaining = +(serviceEstimate - deposit).toFixed(2);

  return {
    base,
    discountPercent: Math.round(freq.discount * 100),
    discountAmount,
    discountedBase,
    addonsTotal,
    addOnsList,
    serviceEstimate,
    deposit,
    remainingBalance: remaining > 0 ? remaining : 0,
    frequencyLabel: freq.label,
  };
}

export const BEDROOM_OPTIONS = [1, 2, 3, 4, 5, 6];
export const BATHROOM_OPTIONS = [1, 2, 3, 4, 5];
